<template>
    <div v-if="listItems.length"
        class="grid grid-cols-1 tablet:grid-cols-2 desktop:grid-cols-3 mobile:gap-[10px] tablet:gap-[15px] laptop:gap-[40px]">

        <div v-for="card in listItems" :key="card.id"
            class="relative p-[10px] laptop:p-[20px] rounded-xl border-[1px] transition shadow-[0px_0px_10px_0px_#00000026] bg-white"
            :class="card.isDefault ? 'border-[#2459A8]' : 'border-[#E5E7EB]'">
            <!-- Delete -->
            <button v-if="listItems.length > 1"
                class="lg:hover:-translate-y-1 lg:hover:scale-[1.02] active:translate-y-0 active:scale-[0.98] duration-300 transition-all group flex w-[30px] h-[30px] p-[5px] rounded-full absolute top-3 right-3 mobile:bg-[#FD5000] laptop:bg-[#E5D3B7]/20 laptop:hover:bg-[#FD5000]"
                @click="removeCard(card.id)" :disabled="loading">
                <img src="../../assets/images/payment-card-delete-icon.svg "
                    class="mobile:hidden laptop:block laptop:group-hover:hidden" />
                <img src="../../assets/images/payment-card-hover-delete-icon.svg "
                    class="mobile:block laptop:hidden laptop:group-hover:block" />
            </button>

            <!-- Card brand -->
            <img :src="getCardIcon(card.type)"
                class="w-[40px] h-[40px] tablet:w-[50px] laptop:w-[60px] tablet:h-[40px] object-contain" />

            <!-- Card number -->
            <p
                class="my-[10px] tablet:mt-[10px] tablet:mb-[15px] text-[20px] tablet:text-[23px] largeDesktop:text-[25px] font-poppins text-[#333]">
                **** **** **** {{ card.last4 }}
            </p>

            <!-- Footer -->
            <div class="flex items-center justify-between">
                <span v-if="card.isDefault"
                    class="py-1 flex items-center gap-[10px] text-[14px] text-[#2459A8] font-medium">
                    <img src="../../assets/images/check-double-purple.png" class="w-[20px] h-[20px]" />
                    Default
                </span>

                <button v-else class="text-[14px] font-poppins !border-[1px] !bg-transparent !text-customYellow-100 laptop:hover:!text-black-100 CustomYellowBtn px-3 py-1 rounded-[5px]
                 CustomYellowBtn" @click="setDefault(card.id)">
                    Mark as Default
                </button>
            </div>
        </div>
    </div>

    <!-- No Record -->
    <div v-else
        class="min-h-[200px] shadow-[0px_0px_10px_0px_#00000026] flex items-center justify-center rounded-[10px]">
        <h2 class="font-poppins text-[20px] text-[#999]">No Record Found</h2>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import visaCard from "../../assets/images/visaCard.svg";
import masterCard from "../../assets/images/masterCard.svg";
import americanExpressCard from "../../assets/images/americanExpresscard.svg"
import genericCard from "../../assets/images/defaultCard.svg";
import { useToast } from "vue-toastification";
const toast = useToast();

export default {
    data() {
        return {
            listItems: [],
            loading: false,
            selectedCardId : null
        };
    },

    computed: {
        ...mapGetters(["paymentCardListing", "cardDefaultResponse", "cardDeleteResponse"]),
    },

    watch: {
        // Update UI after fetching card listing
        paymentCardListing(data) {
            if (!data) return;

            this.loading = false;
            this.listItems = data.body.map((card) => ({
                id: card.id,
                type: card.credit_card_type,
                last4: card.last_digits,
                isDefault: card.is_default === "1",
                active: card.active === "1",
            }));      
        },

        // Refresh cards after default card API call
        cardDefaultResponse(data) {
            if (!data) return;
            toast.success("Your default payment method has been updated successfully.")
            this.$emit('event' , this.selectedCardId)
            this.getCardListing();
        },

        // Refresh cards after delete card API call
        cardDeleteResponse(data) {
            if (!data) return;
            toast.success("Card has been deleted successfully.")
            this.getCardListing();
        },
    },

    mounted() {
        this.loading = true;
        this.getCardListing();


    },

    methods: {
        ...mapActions(["getCardListing", "getCardDefault", "getCardDelete"]),

        // Set default card
        setDefault(cardId) {
            this.selectedCardId = cardId
            this.loading = true;
            this.getCardDefault({ card_id: cardId });
        },

        // Delete card
        removeCard(cardId) {
            this.$dialog.show({
                title: "Delete Card",
                text: "Are you sure you want to delete this card?",
                // image: "pop-req-img.png",
                // we are passing callback method for our confirm button
                onConfirm: () => {
                    this.loading = true;
                    this.getCardDelete({ card_id: cardId });
                },
            });
        },

        // Card brand icon
        getCardIcon(type) {
            switch (type) {
                case "visa":
                    return visaCard;
                case "mastercard":
                    return masterCard;
                case "amex":
                    return americanExpressCard;
                default:
                    return genericCard;
            }
        },
    },
};
</script>
